export const bands = [
  {
    name: "Bruno Mars",
    songs: [
      {
        title: "Uptown Funk",
      },
    ],
    language: "English",
  },
  {
    name: "STIG",
    songs: [
      {
        title: "Roy Orbison",
      },
    ],
    language: "Finnish",
  },
  {
    name: "Coldplay",
    songs: [
      {
        title: "Feelslikeimfallinginlove",
      },
    ],
    language: "English",
  },
  {
    name: "Ramses II",
    songs: [
      {
        title: "Villi Eläin",
      },
    ],
    language: "Finnish",
  },
  {
    name: "Käärijä",
    songs: [
      {
        title: "Cha Cha Cha",
      },
      { title: "Ruoska" },
    ],
    language: "Finnish",
  },
  {
    name: "Bruce Springsteen",
    songs: [
      {
        title: "Dancing In The Dark",
      },
    ],
    language: "English",
  },
  {
    name: "Gasellit",
    songs: [
      {
        title: "Imus",
      },
    ],
    language: "Finnish",
  },
  {
    name: "Ed Sheeran",
    songs: [
      {
        title: "Perfect",
      },
      {
        title: "Shape of You",
      },
    ],
    language: "English",
  },
  {
    name: "Portion Boys",
    songs: [
      {
        title: "Vauhti Kiihtyy",
      },
    ],
    language: "Finnish",
  },
  {
    name: "Antti Tuisku",
    songs: [
      {
        title: "Hyökyaalto",
      },
      {
        title: "Rahan takii",
      },
    ],
    language: "Finnish",
  },
  {
    name: "Lauri Tähkä",
    songs: [
      {
        title: "Nukkuvat aamut",
      },
    ],
    language: "Finnish",
  },
  {
    name: "Outkast",
    songs: [
      {
        title: "Hey Ya!",
      },
    ],
    language: "English",
  },
  {
    name: "Olavi Uusivirta",
    songs: [
      {
        title: "On niin helppo olla onnellinen",
      },
      {
        title: "Kultaa hiuksissa",
      },
    ],
    language: "Finnish",
  },
  {
    name: "Muse",
    songs: [
      {
        title: "Starlight",
      },
    ],
    language: "English",
  },
  {
    name: "MGMT",
    songs: [
      {
        title: "Kids",
      },
    ],
    language: "English",
  },
  {
    name: "Virve Rosti",
    songs: [
      {
        title: "Sata salamaa",
      },
    ],
    language: "Finnish",
  },
  {
    name: "Kirka",
    songs: [
      {
        title: "Hetki lyö",
      },
      {
        title: "Pääsi rinnallein painuu",
      },
      {
        title: "Hengaillaan",
      },
    ],
    language: "Finnish",
  },
  {
    name: "Neil Young",
    songs: [
      {
        title: "Harvest Moon",
      },
    ],
    language: "English",
  },
  {
    name: "YOUNGHEARTED",
    songs: [
      {
        title: "Hyvä näin",
      },
    ],
    language: "Finnish",
  },
  {
    name: "Beyoncé",
    songs: [
      {
        title: "Crazy In Love",
      },
    ],
    language: "English",
  },
  {
    name: "Van Morrison",
    songs: [
      {
        title: "Moondance",
      },
    ],
    language: "English",
  },
  {
    name: "Jarkko Martikainen",
    songs: [
      {
        title: "Valssi tanssitaidottomille",
      },
    ],
    language: "Finnish",
  },
  {
    name: "JVG",
    songs: [
      {
        title: "Häissä",
      },
    ],
    language: "Finnish",
  },
  {
    name: "Anssi Kela",
    songs: [
      {
        title: "1972",
      },
    ],
    language: "Finnish",
  },
  {
    name: "The Doors",
    songs: [
      {
        title: "Hello, I Love You",
      },
    ],
    language: "English",
  },
  {
    name: "BEHM",
    songs: [
      {
        title: "Hei rakas",
      },
    ],
    language: "Finnish",
  },
  {
    name: "Henry Mancini",
    songs: [
      {
        title: "Moon River",
      },
    ],
    language: "English",
  },
  {
    name: "Blondie",
    songs: [
      {
        title: "Maria",
      },
    ],
    language: "English",
  },
  {
    name: "The Doobie Brothers",
    songs: [
      {
        title: "Long Train Runnin",
      },
    ],
    language: "English",
  },
  {
    name: "Chuck Berry",
    songs: [
      {
        title: "You Never Can Tell",
      },
    ],
    language: "English",
  },
  {
    name: "Hurriganes",
    songs: [
      {
        title: "Get On",
      },
    ],
    language: "Finnish",
  },
  {
    name: "Juha Tapio",
    songs: [
      {
        title: "Mä tykkään susta niin että halkeen",
      },
    ],
    language: "Finnish",
  },
  {
    name: "Tuure Kilpeläinen",
    songs: [
      {
        title: "Autiosaari",
      },
    ],
    language: "Finnish",
  },
  {
    name: "Leevi And The Leavings",
    songs: [
      {
        title: "Amalia",
      },
      {
        title: "Pohjois-Karjala",
      },
    ],
    language: "Finnish",
  },
  {
    name: "Elvis Presley",
    songs: [
      {
        title: "Jailhouse Rock",
      },
      {
        title: "Can't Help Falling In Love",
      },
    ],
    language: "English",
  },
  {
    name: "J. Karjalainen",
    songs: [
      {
        title: "Villejä Lupiineja",
      },
      {
        title: "Sekaisin",
      },
    ],
    language: "Finnish",
  },
  {
    name: "Jefferson Airplane",
    songs: [
      {
        title: "Somebody To Love",
      },
    ],
    language: "English",
  },
  {
    name: "The Sounds",
    songs: [
      {
        title: "Living in America",
      },
    ],
    language: "English",
  },
  {
    name: "Miljoonasade",
    songs: [
      {
        title: "Marraskuu",
      },
    ],
    language: "Finnish",
  },
  {
    name: "fun.",
    songs: [
      {
        title: "We Are Young",
      },
    ],
    language: "English",
  },
  {
    name: "Madonna",
    songs: [
      {
        title: "Like A Virgin",
      },
    ],
    language: "English",
  },
  {
    name: "Duran Duran",
    songs: [
      {
        title: "Ordinary World",
      },
    ],
    language: "English",
  },
  {
    name: "Ville Valo",
    songs: [
      {
        title: "Olet mun kaikuluotain",
      },
    ],
    language: "Finnish",
  },
  {
    name: "Tapio Rautavaara",
    songs: [
      {
        title: "Uralin pihlaja",
      },
    ],
    language: "Finnish",
  },
  {
    name: "Bloodhound Gang",
    songs: [
      {
        title: "Bad Touch",
      },
    ],
    language: "English",
  },
  {
    name: "Kari Kuuva",
    songs: [
      {
        title: "Tango pelargonia",
      },
    ],
    language: "Finnish",
  },
  {
    name: "Bon Jovi",
    songs: [
      {
        title: "Runaway",
      },
      {
        title: "Always",
      },
    ],
    language: "English",
  },
  {
    name: "Sir Elwoodin Hiljaiset Värit",
    songs: [
      {
        title: "Älä mee",
      },
    ],
    language: "Finnish",
  },
  {
    name: "Pelle Miljoona",
    songs: [
      {
        title: "Tahdon rakastella sinua",
      },
    ],
    language: "Finnish",
  },
  {
    name: "Queen",
    songs: [
      {
        title: "Crazy Little Thing Called Love",
      },
      {
        title: "Don't Stop Me Now",
      },
    ],
    language: "English",
  },
  {
    name: "Guns N’ Roses",
    songs: [
      {
        title: "November Rain, Welcome To The Jungle",
      },
    ],
    language: "English",
  },
  {
    name: "Of Monsters and Men",
    songs: [
      {
        title: "Little Talks",
      },
    ],
    language: "English",
  },
  {
    name: "Blur",
    songs: [
      {
        title: "Song 2",
      },
    ],
    language: "English",
  },
  {
    name: "Asa",
    songs: [
      {
        title: "Taulu",
      },
    ],
    language: "Finnish",
  },
  {
    name: "Dominik Hauser",
    songs: [
      {
        title: "Love Boat",
      },
    ],
    language: "English",
  },
  {
    name: "Desireless",
    songs: [
      {
        title: "Voyage Voyage",
      },
    ],
    language: "French",
  },
  {
    name: "Rage Against The Machine",
    songs: [
      {
        title: "Killing In The Name",
      },
    ],
    language: "English",
  },
  {
    name: "Bombfunk MC's",
    songs: [
      {
        title: "Freestyler",
      },
    ],
    language: "English",
  },
  {
    name: "Antti Autio",
    songs: [
      {
        title: "Pihkassa",
      },
    ],
    language: "Finnish",
  },
  {
    name: "Marilii",
    songs: [
      {
        title: "Nautin elämästä",
      },
    ],
    language: "Finnish",
  },
  {
    name: "Pekka Ruuska",
    songs: [
      {
        title: "Rafaelin enkeli",
      },
    ],
    language: "Finnish",
  },
  {
    name: "The Proclaimers",
    songs: [
      {
        title: "I'm Gonna Be (500 Miles)",
      },
    ],
    language: "Scottish",
  },
  {
    name: "Pate Mustajärvi",
    songs: [
      {
        title: "Ukkometso",
      },
    ],
    language: "Finnish",
  },
  {
    name: "Neil Diamond",
    songs: [
      {
        title: "Sweet Caroline",
      },
    ],
    language: "English",
  },
  {
    name: "Hector",
    songs: [
      {
        title: "Juodaan viinaa",
      },
      {
        title: "Yhtenä iltana",
      },
    ],
    language: "Finnish",
  },
  {
    name: "Foo Fighters",
    songs: [
      {
        title: "Pretender",
      },
    ],
    language: "English",
  },
  {
    name: "Rauli Badding Somerjoki",
    songs: [
      {
        title: "Ikkunaprinsessa",
      },
      {
        title: "Valot",
      },
      {
        title: "Paratiisi",
      },
    ],
    language: "Finnish",
  },
  {
    name: "Topi Sorsakoski",
    songs: [
      {
        title: "Cherbourgin sateenvarjot",
      },
    ],
    language: "Finnish",
  },
  {
    name: "Apulanta",
    songs: [
      {
        title: "Piiskaa",
      },
    ],
    language: "Finnish",
  },
  {
    name: "Jack Johnson",
    songs: [
      {
        title: "Better Together",
      },
    ],
    language: "English",
  },
  {
    name: "22-pistepirkko",
    songs: [
      {
        title: "Birdy",
      },
    ],
    language: "Finnish",
  },
  {
    name: "Tuomari Nurmio",
    songs: [
      {
        title: "Lasten mehuhetki",
      },
    ],
    language: "Finnish",
  },
  {
    name: "Anna Puu",
    songs: [
      {
        title: "Kolme vuodenaikaa",
      },
    ],
    language: "Finnish",
  },
  {
    name: "Dingo",
    songs: [
      {
        title: "Levoton tuhkimo",
      },
      {
        title: "Autiotalo",
      },
    ],
    language: "Finnish",
  },
  {
    name: "Adele",
    songs: [
      {
        title: "Rolling In The Deep",
      },
    ],
    language: "English",
  },
  {
    name: "Tiktak",
    songs: [
      {
        title: "Heilutaan",
      },
    ],
    language: "Finnish",
  },
  {
    name: "Tehosekoitin",
    songs: [
      {
        title: "Pillitä Elli pillitä",
      },
      {
        title: "Kaikki nuoret tyypit",
      },
    ],
    language: "Finnish",
  },
  {
    name: "Aki Sirkesalo",
    songs: [
      {
        title: "Naispaholainen",
      },
    ],
    language: "Finnish",
  },
  {
    name: "The Killers",
    songs: [
      {
        title: "Human",
      },
    ],
    language: "English",
  },
  {
    name: "Red Hot Chili Peppers",
    songs: [
      {
        title: "Can't Stop",
      },
    ],
    language: "English",
  },
  {
    name: "Eppu Normaali",
    songs: [
      {
        title: "Vihreä joen rannalla",
      },
    ],
    language: "Finnish",
  },
  {
    name: "Toto",
    songs: [
      {
        title: "Africa",
      },
    ],
    language: "English",
  },
  {
    name: "Roxette",
    songs: [
      {
        title: "Sleeping In My Car",
      },
    ],
    language: "Swedish",
  },
  {
    name: "Pepe Willberg",
    songs: [
      {
        title: "Aamu",
      },
      {
        title: "Elämältä kaiken sain",
      },
    ],
    language: "Finnish",
  },
  {
    name: "Stevie Wonder",
    songs: [
      {
        title: "I Wish",
      },
    ],
    language: "English",
  },
  {
    name: "Samuli Edelmann",
    songs: [
      {
        title: "Peggy",
      },
    ],
    language: "Finnish",
  },
  {
    name: "Metallica",
    songs: [
      {
        title: "Nothing Else Matters",
      },
    ],
    language: "English",
  },
  {
    name: "Rihanna",
    songs: [
      {
        title: "Umbrella",
      },
    ],
    language: "English",
  },
  {
    name: "The Beatles",
    songs: [
      {
        title: "Hey Jude",
      },
    ],
    language: "English",
  },
  {
    name: "Haddaway",
    songs: [
      {
        title: "What Is Love",
      },
    ],
    language: "English",
  },
  {
    name: "David Bowie",
    songs: [
      {
        title: "Life On Mars",
      },
      {
        title: "The Man Who Sold The World",
      },
    ],
    language: "English",
  },
  {
    name: "Matti ja Teppo",
    songs: [
      {
        title: "Kaiken takana on nainen",
      },
      {
        title: "Mä joka päivä töitä teen",
      },
    ],
    language: "Finnish",
  },
  {
    name: "Popeda",
    songs: [
      {
        title: "Repe ja Lissu",
      },
    ],
    language: "Finnish",
  },
  {
    name: "Pekka Streng",
    songs: [
      {
        title: "Puutarhassa",
      },
      {
        title: "Perhonen",
      },
    ],
    language: "Finnish",
  },
  {
    name: "Neon 2",
    songs: [
      {
        title: "Kemiaa",
      },
    ],
    language: "Finnish",
  },
  {
    name: "Pulp",
    songs: [
      {
        title: "Disco 2000",
      },
    ],
    language: "English",
  },
  {
    name: "The Black Keys",
    songs: [
      {
        title: "Lonely Boy",
      },
    ],
    language: "English",
  },
  {
    name: "Abba",
    songs: [
      {
        title: "Does Your Mother Know?",
      },
      {
        title: "Dancing Queen",
      },
      {
        title: "Gimme! Gimme! Gimme! (A Man After Midnight)",
      },
    ],
    language: "Swedish",
  },
  {
    name: "Elton John",
    songs: [
      {
        title: "Something About the Way You Look Tonight",
      },
      {
        title: "I'm Still Standing",
      },
    ],
    language: "English",
  },
  {
    name: "Smash Mouth",
    songs: [
      {
        title: "I'm a Believer",
      },
    ],
    language: "English",
  },
  {
    name: "Petshop Boys",
    songs: [
      {
        title: "Always on My Mind",
      },
    ],
    language: "English",
  },
  {
    name: "Egotrippi",
    songs: [
      {
        title: "Varovasti nyt",
      },
    ],
    language: "Finnish",
  },
  {
    name: "U2",
    songs: [
      {
        title: "Beautiful Day",
      },
    ],
    language: "English",
  },
  {
    name: "Karri Koira",
    songs: [
      {
        title: "Ne kutsuu mua koiraks",
      },
    ],
    language: "Finnish",
  },
  {
    name: "Karri Koira",
    songs: [
      {
        title: "Ne kutsuu mua koiraks",
      },
    ],
    language: "Finnish",
  },
  {
    name: "Erika Vikman",
    songs: [
      {
        title: "Ruoska",
      },
    ],
    language: "Finnish",
  },
  {
    name: "Sting",
    songs: [
      {
        title: "Fields Of Gold",
      },
    ],
    language: "English",
  },
  {
    name: "Tom Jones",
    songs: [
      {
        title: "It's Not Unusual",
      },
    ],
    language: "English",
  },
  {
    name: "Robin Packalen",
    songs: [
      {
        title: "Häitä pidelly",
      },
    ],
    language: "Finnish",
  },
  {
    name: "Brtiney Spears",
    songs: [
      {
        title: "Toxic",
      },
    ],
    language: "English",
  },
  {
    name: "Haloo Helsinki",
    songs: [
      {
        title: "Reiviluola",
      },
    ],
    language: "Finnish",
  },
];



// WEBPACK FOOTER //
// ./src/components/BandsTable.js